export const TopupAndWithdrawConst = {
  TOPUP: "topup",
  WITHDRAW: "withdraw",
};
